import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
interface CTABandProps {
  headline: string;
  copy: string;
}
export function CTABand({
  headline,
  copy
}: CTABandProps) {
  return <section className="relative py-24 overflow-hidden bg-ink" data-id="element-76">
      {/* Abstract diagonal background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-charcoal transform skew-x-12 translate-x-20 opacity-50 pointer-events-none" data-id="element-77" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-78">
        <h2 className="text-4xl md:text-5xl text-white mb-6" data-id="element-79">{headline}</h2>
        <p className="text-xl text-gray-warm mb-10 max-w-2xl mx-auto" data-id="element-80">{copy}</p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-81">
          <Link to="/free-trial" className="btn-primary w-full sm:w-auto" data-id="element-82">
            Claim Your Free Week
          </Link>
          <a href="tel:517-220-0621" className="btn-outline border-gray-warm text-white hover:bg-white hover:text-ink w-full sm:w-auto gap-2" data-id="element-83">
            <Phone className="w-5 h-5" data-id="element-84" />
            Call 517-220-0621
          </a>
        </div>
      </div>
    </section>;
}